module["exports"] = [
  "#####",
  "### ##",
  "## ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/address/postcode.js
// module id = 2683
// module chunks = 2